import { Component, OnInit } from '@angular/core';
import { QuestionsService } from '../services/questions.service';

@Component({
  selector: 'app-questionhome',
  templateUrl: './questionhome.component.html',
  styleUrls: ['./questionhome.component.css']
})
export class QuestionhomeComponent implements OnInit {
  results = [];
  constructor(private questionService: QuestionsService) { }

  ngOnInit() {
  }

  search(text){
    this.questionService.searchquestion(text.value).subscribe(res=>{
      this.results = res.results;
      //console.log(this.results);
    });
  }

}
